import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import i18n from "../../../../constants/i18n";
import ET3Div from "../../../../core/et3-div";
import Et3Date from "../../../../core/et3-input/et3-date";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import { faComment } from "@fortawesome/free-solid-svg-icons";
import getWebPayments from "../../../../stores/auditor-store/web-payments";

const SearchByDateOrUser = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const webPaymentChoiceValue = getWebPayments().webPaymentChoiceValue.get();
  const webPaymentsUserID = getWebPayments().webPaymentsUserID.get();

  return webPaymentChoiceValue === "BY_USER_ID" ? (
    <Et3TextInput
      size="MEDIUM"
      withShadow={true}
      type={"number"}
      icon={faComment}
      label={i18n.get("USER_ID")}
      placeHolder={i18n.get("USER_ID")}
      value={webPaymentsUserID}
      onChoose={(value) => {
        const valueParseInt = parseInt(`${value}`, 10);
        getWebPayments().webPaymentsUserID.set(valueParseInt);
      }}
      onBlur={() => {}}
      onEnter={() => {}}
      style={{}}
    />
  ) : webPaymentChoiceValue === "BY_EMAIL" ? (
    <Et3TextInput
      size="MEDIUM"
      withShadow={true}
      type={"text"}
      icon={faComment}
      label={i18n.get("EMAIL")}
      placeHolder={i18n.get("EMAIL")}
      value={getWebPayments().webPaymentsEmail.get()}
      onChoose={(value: string) => {
        getWebPayments().setWebPaymentEmail(value);
      }}
      onBlur={() => {}}
      onEnter={() => {}}
      style={{}}
    />
  ) : webPaymentChoiceValue === "BY_TRANSACTION_ID" ? (
    <Et3TextInput
      size="MEDIUM"
      withShadow={true}
      type={"text"}
      icon={faComment}
      label={i18n.get("TRANSACTION_ID")}
      placeHolder={i18n.get("TRANSACTION_ID")}
      value={getWebPayments().webPaymentsTransactionID.get()}
      onChoose={(value: string) => {
        getWebPayments().setWebPaymentTransactionID(value);
      }}
      onBlur={() => {}}
      onEnter={() => {}}
      style={{}}
    />
  ) : (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={1200}
      height={75}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Date
        hasMax={true}
        hasMin={false}
        label={i18n.get("DATE_MIN")}
        dateInputObservable={getWebPayments().fromDate}
        isEnabled={true}
      />
      <Et3Margin top={0} bottom={0} right={30} left={0} />
      <Et3Date
        hasMax={true}
        hasMin={false}
        label={i18n.get("DATE_MAX")}
        dateInputObservable={getWebPayments().toDate}
        isEnabled={true}
      />
    </ET3Div>
  );
});
export default SearchByDateOrUser;
